import React from 'react';
import { Modal, Button } from 'antd';
import AnswerView from './AnswerView';
import { sortQuestionEntries, } from 'lib';

function cleanQuestionEntries(questionEntries) {
  return questionEntries.filter(questionEntry => {
    if (!questionEntry[1].name.includes('Finish Page')) return questionEntry;
  });
}

export default function AnswersModal(props) {
  const sortedQuestions = sortQuestionEntries(props.quiz);
  const questionEntries = cleanQuestionEntries(sortedQuestions);
  const [index, setIndex] = React.useState(0);
  const [disablePrev, setDisablePrev] = React.useState(true);
  const [disableNext, setDisableNext] = React.useState(false);
  const handlePrevious = () => {
    if (index > 0) setIndex(index - 1);
  }
  const handleNext = () => {
    if (index < questionEntries.length-1) setIndex(index + 1);
  }
  const handleCancel = () => props.onCancel();
  const handleOk = () => {}

  React.useEffect(() => {
    if (index === 0) {
      if (!disablePrev) setDisablePrev(true);
    } else {
      if (disablePrev) setDisablePrev(false);
    }

    if (index === questionEntries.length-1) {
      if (!disableNext) setDisableNext(true);
    } else {
      if (disableNext) setDisableNext(false);
    }
  }, [index]);

  return (
    <Modal
      visible={props.visible}
      keyboard
      width="75%"
      title={props.quizName}
      centered
      destroyOnClose={true}
      maskClosable={false}
      onCancel={handleCancel}
      footer={[
        <Button type="primary" onClick={handlePrevious} disabled={disablePrev}>
          previous
        </Button>,
        <Button type="primary" onClick={handleNext} disabled={disableNext}>
          next
        </Button>,
      ]}
    >
      <AnswerView question={questionEntries[index][1]} />
    </Modal>
  );
}
